import { CloseOutlined, DeleteOutlined, EditOutlined, SendOutlined,CheckOutlined, SaveOutlined} from '@ant-design/icons';
import { Button, Checkbox, Col, DatePicker, FloatButton, Input, Row, Space, Table, Tabs } from "antd";
import Column from 'antd/es/table/Column';
import dayjs, { Dayjs } from 'dayjs';
import { useEffect, useState } from 'react';
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from 'react-router-dom';
import { toast } from "react-toastify";
import { ContentHeader } from "../../components";
import ModalTextForm from "../../components/modal/ModalTextForm";
import { trangThaiLopDaoTao, urlAdmin } from "../../constants";
import { Links } from "../../helpers/Links";
import { menuHelper } from "../../helpers/account";
import { dateCommon, formatVND, shortFileName } from "../../helpers/common";
import { ChungChiKetQuaDaoTao, LopDaoTao, NhanVienTheoLopDaoTao } from "../../models/daotao/LopDaoTao";
import LoadingDetailPage from "../../modules/loading/LoadingDetailPage";
import { capNhatKetQuaDaoTao, hoanThanhLopDaoTao, layChiTiet, pheDuyetLopDaoTao, xoaLopDaoTao } from "../../services/daotao";
import LogNguoiDungTable from "../utils/LogNguoiDungTable";
import TrangThaiLopDaoTaoTag from "./TrangThaiLopDaoTaoTag";
import { hideLoadingScreen, showLoadingScreen } from '../../store/reducers/loading';

/** thông tin chứng chỉ đang nhập trên form kết quả đào tạo */
type ChungChiEdit = {
    idChungChi: number | null;
    tenChungChi: string;
    loaiChungChi: string;
    donViCap: string;
    xepLoai: string;
    ngayCapChungChi: Dayjs | null;
    apDungTuNgay: Dayjs | null;
    apDungDenNgay: Dayjs | null;
};

const chuyenSangDayjs = (date?: Date | null) => date ? dayjs(dateCommon.formatDate(date), "DD/MM/YYYY") : null;

/** khởi tạo dữ liệu nhập chứng chỉ từ chứng chỉ đã cấp (nếu có) */
const taoChungChiEdit = (chungChi?: ChungChiKetQuaDaoTao | null): ChungChiEdit => ({
    idChungChi: chungChi?.idChungChi ?? null,
    tenChungChi: chungChi?.tenChungChi || "",
    loaiChungChi: chungChi?.loaiChungChi || "",
    donViCap: chungChi?.donViCap || "",
    xepLoai: chungChi?.xepLoai || "",
    ngayCapChungChi: chuyenSangDayjs(chungChi?.ngayCapChungChi),
    apDungTuNgay: chuyenSangDayjs(chungChi?.apDungTuNgay),
    apDungDenNgay: chuyenSangDayjs(chungChi?.apDungDenNgay),
});

const XemLopDaoTao = () => {
    let navigate = useNavigate();
    const params = new URLSearchParams(window.location.search);
    let id = params.get('id') || '0';
    const [loading, setLoading] = useState(false);

    const [rowIndex, setRowIndex] = useState(-1);
    // bản ghi kết quả đào tạo đang được nhập ở dòng rowIndex
    const [ketQuaEdit, setKetQuaEdit] = useState<NhanVienTheoLopDaoTao | null>(null);
    // thông tin chứng chỉ nhập kèm khi tích "Cấp chứng chỉ"
    const [chungChiEdit, setChungChiEdit] = useState<ChungChiEdit>(taoChungChiEdit());
    const dispatch = useDispatch();
    const [confirmModal, setConfirmModal] = useState<any>({});
    const [lyDo, setLyDo] = useState<string>("");
    const user = useSelector((state: any) => state.auth.currentUser);
    const [dsNhanVien, setDsNhanVien] = useState<Array<NhanVienTheoLopDaoTao>>([]);
    const [data, setData] = useState<LopDaoTao>(new LopDaoTao);
    const menu: any = menuHelper.checkMultiPermission([Links.DaoTao.ChiTiet, Links.DangKyDaoTao.PheDuyetTongHop]);
    const [openModalXoa, setOpenModalXoa] = useState(false);

    const [activeTab, setActiveTab] = useState<string>("1");
    const layCT = async (id: number) => {
        setLoading(true);
        try {
            if (id > 0) {
                var data = await layChiTiet(id);
                setData(data);
                setDsNhanVien(data.dsNhanVien);
                setLoading(false);
            }
        }
        catch (error: any) {
            toast.error("Lớp đào tạo không tồn tại!");
            setLoading(false);
        }
    }

    const xoa = async () => {
        try {
            setLoading(true);
            await xoaLopDaoTao(parseInt(id));
            setLoading(false);
            setOpenModalXoa(false);
            toast.success('Xóa lớp đào tạo thành công');
            navigate(Links.DaoTao.DanhSach);
        }
        catch (error: any) {
            setLoading(false);
            setOpenModalXoa(false);
            toast.error('Xóa lớp đào tạo không thành công! Vui lòng thử lại.');
        };
    };

    const handlePheDuyet = async (isDuyet: boolean) => {
        const saveData = {
            id: parseInt(id),
            isDuyet: isDuyet
        };
        setConfirmModal({
            isShowModal: true,
            title: isDuyet && isNVTheoDoi ? (isPheDuyet ? "Phê duyệt lớp đào tạo" : "Trình lớp đào tạo") : (isDuyet ? "Phê duyệt Lớp đào tạo" : "Từ chối Lớp đào tạo"),
            content: isDuyet && isNVTheoDoi ? (isPheDuyet ? <>Bạn có muốn chuyển trạng thái lớp đào tạo thành <strong>Phê duyệt</strong> không? Hãy nhập nội dung (nếu có)</>
                : <>Bạn có muốn <strong>Trình</strong> thông tin lớp đào tạo này không? Hãy nhập nội dung (nếu có)</>)
                : (isDuyet ? <>Bạn có muốn <strong>Duyệt</strong> thông tin lớp đào tạo này không? Hãy nhập nội dung (nếu có)</>
                : <>Bạn có muốn <strong>Từ chối</strong> thông tin lớp đào tạo này không? Hãy nhập nội dung (nếu có)</>),
            onSubmit: (currentLyDo: string) => submitPheDuyet(saveData, currentLyDo),
            showLyDo: true
        });
    };
    useEffect(() => {
        setLoading(true);
        if (parseInt(id) > 0) {
            layCT(parseInt(id));
        }
        setLoading(false);
    }, []);
    const trangThai = data.trangThai;
    const isNVTheoDoi = (user.idNhanVien == data.idNVTheoDoi || user.isAdmin) && (trangThai < trangThaiLopDaoTao.trinhPhoCVP ||
        (data.idPhoCVP > 0 && trangThai == trangThaiLopDaoTao.phoCVPTraLai) ||
        (data.idPhoCVP == 0 && data.idChanhVP > 0 && trangThai == trangThaiLopDaoTao.chanhVPTraLai) ||
        (data.idPhoCVP == 0 && data.idChanhVP == 0 && data.idPhoGiamDoc > 0 && trangThai == trangThaiLopDaoTao.phoGiamDocTraLai) ||
        (data.idPhoCVP == 0 && data.idChanhVP == 0 && data.idPhoGiamDoc == 0 && data.idGiamDoc > 0 && trangThai == trangThaiLopDaoTao.giamDocTraLai));

    const isPhoCVP = menu[Links.DangKyDaoTao.PheDuyetTongHop] && user.idNhanVien == data.idPhoCVP
        && (trangThai == trangThaiLopDaoTao.trinhPhoCVP || (data.idChanhVP > 0 && trangThai == trangThaiLopDaoTao.chanhVPTraLai) ||
        (data.idChanhVP == 0 && data.idPhoGiamDoc > 0 && trangThai == trangThaiLopDaoTao.phoGiamDocTraLai) ||
        (data.idChanhVP == 0 && data.idPhoGiamDoc == 0 && data.idGiamDoc > 0 && trangThai == trangThaiLopDaoTao.giamDocTraLai));

    const ischanhVP = menu[Links.DangKyDaoTao.PheDuyetTongHop] &&  user.idNhanVien == data.idChanhVP
        && (trangThai == trangThaiLopDaoTao.trinhCVP || (data.idPhoGiamDoc > 0 && trangThai == trangThaiLopDaoTao.phoGiamDocTraLai) ||
        (data.idPhoGiamDoc == 0 && data.idGiamDoc > 0 && trangThai == trangThaiLopDaoTao.giamDocTraLai));

    const isPhoGiamDoc = menu[Links.DangKyDaoTao.PheDuyetTongHop] &&user.idNhanVien == data.idPhoGiamDoc
        && (trangThai == trangThaiLopDaoTao.trinhPhoGiamDoc ||(data.idGiamDoc > 0 && trangThai == trangThaiLopDaoTao.giamDocTraLai));

    const isGiamDoc = menu[Links.DangKyDaoTao.PheDuyetTongHop] && user.idNhanVien == data.idGiamDoc
        && trangThai == trangThaiLopDaoTao.trinhGiamDoc;
    const isPheDuyet = (user.idNhanVien == data.idNVTheoDoi || user.isAdmin) && data.idPhoCVP == 0 && data.idChanhVP == 0 && data.idPhoGiamDoc == 0 && data.idGiamDoc == 0;
    const isHoanThanh = user.idNhanVien == data.idNVTheoDoi && [trangThaiLopDaoTao.pheDuyet].includes(trangThai);
    const submitPheDuyet = async (value: any, currentLyDo?: string) => {
        try {
            dispatch(showLoadingScreen());
            await pheDuyetLopDaoTao({ ...value, lyDo: currentLyDo || lyDo });
            dispatch(hideLoadingScreen());
            toast.success(isNVTheoDoi ? isPheDuyet ? "Cập nhật trạng thái thành công" : "Trình lớp đào tạo thành công" : (value.isDuyet ? "Phê duyệt Lớp đào tạo thành công" : 'Từ chối Lớp  đào tạo năm thành công!'));
            await layCT(data.id);
        }
        catch (error: any) {
            dispatch(hideLoadingScreen());
            toast.error(error.message || "Vui lòng thử lại");
        };
    };
    /** xác nhận hoàn thành lớp học */
    const handleHoanThanh = () => {
        setConfirmModal({
            isShowModal: true,
            title: "Hoàn thành lớp học",
            content: <>Bạn có muốn <strong>Hoàn thành</strong> lớp đào tạo này không?</>,
            onSubmit: () => submitHoanThanh()
        });
    };

    const submitHoanThanh = async () => {
        try {
            dispatch(showLoadingScreen());
            await hoanThanhLopDaoTao(parseInt(id));
            dispatch(hideLoadingScreen());
            huyCapNhatKetQua();
            toast.success("Hoàn thành lớp đào tạo thành công");
            await layCT(parseInt(id));
        }
        catch (error: any) {
            dispatch(hideLoadingScreen());
            toast.error(error.message || "Hoàn thành lớp đào tạo không thành công! Vui lòng thử lại.");
        };
    };

    /** mở ô nhập kết quả đào tạo của 1 nhân viên */
    const batDauCapNhatKetQua = (index: number, nhanVien: NhanVienTheoLopDaoTao) => {
        setRowIndex(index);
        setKetQuaEdit({ ...nhanVien });
        setChungChiEdit(taoChungChiEdit(nhanVien.chungChi));
    };

    const huyCapNhatKetQua = () => {
        setRowIndex(-1);
        setKetQuaEdit(null);
        setChungChiEdit(taoChungChiEdit());
    };

    /** kiểm tra thông tin chứng chỉ trước khi lưu, trả về thông báo lỗi đầu tiên nếu có */
    const kiemTraChungChi = () => {
        if (!chungChiEdit.tenChungChi.trim()) return "Vui lòng nhập tên chứng chỉ";
        if (!chungChiEdit.loaiChungChi.trim()) return "Vui lòng nhập loại chứng chỉ";
        if (!chungChiEdit.donViCap.trim()) return "Vui lòng nhập đơn vị cấp chứng chỉ";
        if (!chungChiEdit.ngayCapChungChi) return "Vui lòng nhập ngày cấp chứng chỉ";
        if (!chungChiEdit.apDungTuNgay) return "Vui lòng nhập ngày áp dụng chứng chỉ";
        if (chungChiEdit.apDungDenNgay && chungChiEdit.apDungDenNgay.isBefore(chungChiEdit.apDungTuNgay, "day")) {
            return "Ngày áp dụng đến ngày phải sau ngày áp dụng từ ngày";
        }
        return "";
    };

    /** lưu kết quả đào tạo của nhân viên đang nhập */
    const luuKetQuaDaoTao = async () => {
        if (!ketQuaEdit) return;
        if (ketQuaEdit.isCapChungChi) {
            var loi = kiemTraChungChi();
            if (loi) {
                toast.error(loi);
                return;
            }
        }
        var chungChi: ChungChiKetQuaDaoTao | null = ketQuaEdit.isCapChungChi ? {
            idChungChi: chungChiEdit.idChungChi,
            tenChungChi: chungChiEdit.tenChungChi.trim(),
            loaiChungChi: chungChiEdit.loaiChungChi.trim(),
            donViCap: chungChiEdit.donViCap.trim(),
            xepLoai: chungChiEdit.xepLoai.trim(),
            ngayCapChungChi: chungChiEdit.ngayCapChungChi!.toDate(),
            apDungTuNgay: chungChiEdit.apDungTuNgay!.toDate(),
            apDungDenNgay: chungChiEdit.apDungDenNgay ? chungChiEdit.apDungDenNgay.toDate() : null,
        } : null;
        try {
            dispatch(showLoadingScreen());
            await capNhatKetQuaDaoTao({
                id: ketQuaEdit.id,
                idLopDaoTao: parseInt(id),
                diemDanhGia: ketQuaEdit.diemDanhGia,
                ketQuaDaoTao: ketQuaEdit.ketQuaDaoTao,
                isCapChungChi: ketQuaEdit.isCapChungChi,
                chungChi: chungChi ? {
                    id: chungChi.idChungChi,
                    tenChungChi: chungChi.tenChungChi,
                    loaiChungChi: chungChi.loaiChungChi,
                    donViCap: chungChi.donViCap,
                    xepLoai: chungChi.xepLoai,
                    ngayCapChungChi: chungChiEdit.ngayCapChungChi!.format("YYYY-MM-DD"),
                    apDungTuNgay: chungChiEdit.apDungTuNgay!.format("YYYY-MM-DD"),
                    apDungDenNgay: chungChiEdit.apDungDenNgay ? chungChiEdit.apDungDenNgay.format("YYYY-MM-DD") : null,
                } : null
            });
            setDsNhanVien(ds => ds.map(x => x.id == ketQuaEdit.id ? { ...x, ...ketQuaEdit, chungChi } : x));
            huyCapNhatKetQua();
            dispatch(hideLoadingScreen());
            toast.success("Cập nhật kết quả đào tạo thành công");
            // lấy lại danh sách để đồng bộ id chứng chỉ vừa được tạo
            await layCT(parseInt(id));
        }
        catch (error: any) {
            dispatch(hideLoadingScreen());
            toast.error(error.message || "Cập nhật kết quả đào tạo không thành công! Vui lòng thử lại.");
        }
    };

    /** ô nhập thông tin chứng chỉ, hiện ngay dưới dòng nhân viên khi tích "Cấp chứng chỉ" */
    const formNhapChungChi = () => (
        <div className="card-outline">
            <div className="mb-2"><b>Thông tin chứng chỉ</b></div>
            <Row gutter={16}>
                <Col span={12}>
                    <div className="mb-1">Tên chứng chỉ <span className="text-danger">*</span></div>
                    <Input
                        value={chungChiEdit.tenChungChi}
                        placeholder="Nhập tên chứng chỉ"
                        onChange={(e) => setChungChiEdit(prev => ({ ...prev, tenChungChi: e.target.value }))}
                    />
                </Col>
                <Col span={6}>
                    <div className="mb-1">Loại chứng chỉ <span className="text-danger">*</span></div>
                    <Input
                        value={chungChiEdit.loaiChungChi}
                        placeholder="Nhập loại chứng chỉ"
                        onChange={(e) => setChungChiEdit(prev => ({ ...prev, loaiChungChi: e.target.value }))}
                    />
                </Col>
                <Col span={6}>
                    <div className="mb-1">Xếp loại</div>
                    <Input
                        value={chungChiEdit.xepLoai}
                        placeholder="Nhập xếp loại"
                        onChange={(e) => setChungChiEdit(prev => ({ ...prev, xepLoai: e.target.value }))}
                    />
                </Col>
            </Row>
            <Row gutter={16} className="mt-2">
                <Col span={6}>
                    <div className="mb-1">Đơn vị cấp <span className="text-danger">*</span></div>
                    <Input
                        value={chungChiEdit.donViCap}
                        placeholder="Nhập đơn vị cấp"
                        onChange={(e) => setChungChiEdit(prev => ({ ...prev, donViCap: e.target.value }))}
                    />
                </Col>
                <Col span={6}>
                    <div className="mb-1">Ngày cấp chứng chỉ <span className="text-danger">*</span></div>
                    <DatePicker
                        changeOnBlur={true}
                        style={{ width: "100%" }}
                        placeholder="Chọn ngày"
                        format={["DD/MM/YYYY", "DDMMYYYY"]}
                        value={chungChiEdit.ngayCapChungChi}
                        onChange={(value) => setChungChiEdit(prev => ({ ...prev, ngayCapChungChi: value }))}
                    />
                </Col>
                <Col span={6}>
                    <div className="mb-1">Áp dụng từ ngày <span className="text-danger">*</span></div>
                    <DatePicker
                        changeOnBlur={true}
                        style={{ width: "100%" }}
                        placeholder="Chọn ngày"
                        format={["DD/MM/YYYY", "DDMMYYYY"]}
                        value={chungChiEdit.apDungTuNgay}
                        onChange={(value) => setChungChiEdit(prev => ({ ...prev, apDungTuNgay: value }))}
                    />
                </Col>
                <Col span={6}>
                    <div className="mb-1">Áp dụng đến ngày</div>
                    <DatePicker
                        changeOnBlur={true}
                        style={{ width: "100%" }}
                        placeholder="Chọn ngày"
                        format={["DD/MM/YYYY", "DDMMYYYY"]}
                        value={chungChiEdit.apDungDenNgay}
                        onChange={(value) => setChungChiEdit(prev => ({ ...prev, apDungDenNgay: value }))}
                    />
                </Col>
            </Row>
            <div className="mt-2 text-muted">
                Chứng chỉ được lưu cùng kết quả đào tạo và hiển thị trong hồ sơ nhân viên. Tệp đính kèm của chứng chỉ được bổ sung tại tab Chứng chỉ trong hồ sơ nhân viên.
            </div>
        </div>
    );

    if (loading) {
        return <LoadingDetailPage title="Đào tạo" />
    }

    return (
        <section style={{ paddingBottom: "60px" }}>
            <ContentHeader title="Lớp đào tạo" />
            {openModalXoa && <ModalTextForm show={openModalXoa}
                title="Xoá lớp đào tạo"
                handleClose={() => setOpenModalXoa(false)}
                handleSave={() => xoa()}>
                Bạn có đồng ý xóa lớp đào tạo này không?
            </ModalTextForm>}

            <ModalTextForm
                show={confirmModal.isShowModal}
                title={confirmModal.title}
                handleClose={() => setConfirmModal({ isShowModal: false })}
                handleSave={() => {
                    if (confirmModal.onSubmit) confirmModal.onSubmit(lyDo);
                    setConfirmModal({ isShowModal: false });
                }}
            >
                <Row>
                    <Col span="24">
                        {confirmModal.content}
                    </Col>
                </Row>
                {
                    confirmModal.showLyDo &&
                    <Row>
                        <Col span="24">
                            <Input.TextArea
                                rows={2}
                                value={lyDo}
                                onChange={(e) => {
                                    setLyDo(e.target.value);
                                }}
                            />
                        </Col>
                    </Row>
                }
            </ModalTextForm>
            <Row>
                <Col span="24">
                    <div className="card-outline">
                        <Tabs accessKey={activeTab} onChange={(e) => setActiveTab(e)}
                            tabBarExtraContent={
                                activeTab == "1" ?
                                    <Space>
                                        {//button trình của nv theo dõi
                                            isNVTheoDoi
                                            && <Button
                                                htmlType="submit"
                                                type="primary"
                                                icon={<SendOutlined />}
                                                onClick={() => { handlePheDuyet(true) }}
                                            >
                                                Trình
                                            </Button>}

                                        {isHoanThanh && <>
                                            <Button
                                                icon={<CheckOutlined rev="" />}
                                                htmlType="submit"
                                                className="hrm-btn-success"
                                                onClick={() => { handleHoanThanh(); }}
                                            >
                                                Hoàn thành lớp học
                                            </Button>
                                        </>}
                                        {isPhoCVP && <>
                                            <Button
                                                type="primary"
                                                icon={<SendOutlined rev="" />}
                                                htmlType="submit"
                                                onClick={() => { handlePheDuyet(true) }}

                                            >
                                                Phê duyệt
                                            </Button>
                                            <Button
                                                type="primary"
                                                className="hrm-btn-delete"
                                                icon={<CloseOutlined rev="" />}
                                                htmlType="submit"
                                                onClick={() => { handlePheDuyet(false) }}

                                            >
                                                Từ chối
                                            </Button>
                                        </>}
                                        {ischanhVP && <>
                                            <Button
                                                type="primary"
                                                icon={<SendOutlined rev="" />}
                                                htmlType="submit"
                                                onClick={() => { handlePheDuyet(true) }}

                                            >
                                                Phê duyệt
                                            </Button>
                                            <Button
                                                type="primary"
                                                className="hrm-btn-delete"
                                                icon={<CloseOutlined rev="" />}
                                                htmlType="submit"
                                                onClick={() => { handlePheDuyet(false) }}

                                            >
                                                Từ chối
                                            </Button>
                                        </>}
                                        {isPhoGiamDoc && <>
                                            <Button
                                                type="primary"
                                                icon={<SendOutlined rev="" />}
                                                htmlType="submit"
                                                onClick={() => { handlePheDuyet(true) }}

                                            >
                                                Phê duyệt
                                            </Button>
                                            <Button
                                                type="primary"
                                                className="hrm-btn-delete"
                                                icon={<CloseOutlined rev="" />}
                                                htmlType="submit"
                                                onClick={() => { handlePheDuyet(false) }}

                                            >
                                                Từ chối
                                            </Button>
                                        </>}
                                        {isGiamDoc && <>
                                            <Button
                                                type="primary"
                                                icon={<SendOutlined rev="" />}
                                                htmlType="submit"
                                                onClick={() => { handlePheDuyet(true) }}

                                            >
                                                Phê duyệt
                                            </Button>
                                            <Button
                                                type="primary"
                                                className="hrm-btn-delete"
                                                icon={<CloseOutlined rev="" />}
                                                htmlType="submit"
                                                onClick={() => { handlePheDuyet(false) }}

                                            >
                                                Từ chối
                                            </Button>
                                        </>}
                                    </Space> : null
                            }
                            items={[
                            {
                                key: '1',
                                label: 'Thông tin trình',
                                children:
                                    <div className="card pt-3 pb-2">
                                        <div className="tab-content" style={{ marginLeft: "20px" }}>
                                            <Row>
                                                <Col span={6}>
                                                    <div className="mb-1">
                                                        <div>Chuyên viên theo dõi</div>
                                                        <label>{data?.tenNVTheoDoi}</label>
                                                    </div>
                                                </Col>
                                                <Col span={6}>
                                                    <div className="mb-1">
                                                        <div>Trạng thái</div>
                                                        <label>
                                                            <TrangThaiLopDaoTaoTag value={data.trangThai} />
                                                        </label>
                                                    </div>
                                                </Col>
                                            </Row>
                                            <Row>
                                                <Col span={6}>
                                                    <div className="mb-1">
                                                        <Checkbox
                                                            checked={data.idPhoCVP > 0}
                                                        >
                                                            Trình Phó Chánh Văn Phòng {data.idPhoCVP ? `(${data.tenPhoCVP})` : null}
                                                        </Checkbox>
                                                    </div>
                                                </Col>
                                                <Col span={6}>
                                                    <div className="mb-1">
                                                        <Checkbox
                                                            checked={data.idChanhVP > 0}
                                                        >
                                                            Trình Chánh Văn Phòng {data.idChanhVP ? `(${data.tenChanhVP})` : null}
                                                        </Checkbox>
                                                    </div>
                                                </Col>
                                                <Col span={6}>
                                                    <div className="mb-1">
                                                        <Checkbox
                                                            checked={data.idPhoGiamDoc > 0}
                                                        >
                                                            Trình Phó Giám đốc phụ trách VP {data.idPhoGiamDoc ? `(${data.tenPhoGiamDoc})` : null}
                                                        </Checkbox>
                                                    </div>
                                                </Col>
                                                <Col span={6}>
                                                    <div className="mb-1">
                                                        <Checkbox
                                                            checked={data.idGiamDoc > 0}
                                                        >
                                                            Trình Giám đốc đơn vị {data.idGiamDoc ? `(${data.tenGiamDoc})` : null}
                                                        </Checkbox>
                                                    </div>
                                                </Col>
                                            </Row>
                                            <Row>
                                                <Col span={24}>
                                                    <div className="mb-1">
                                                        <div>File trình</div>
                                                        {(data.taiLieuTrinh || []).length > 0
                                                            ? <Space wrap>
                                                                {(data.taiLieuTrinh || []).map((file, index) => (
                                                                    <Space key={index} size={4}>
                                                                        <a
                                                                            href={urlAdmin + file.duongDan?.replace(/\\/g, "/")}
                                                                            target="_blank"
                                                                            rel="noreferrer"
                                                                        >
                                                                            <Button
                                                                                className="hrm-btn hrm-btn-sm hrm-btn-primary"
                                                                                title={"Xem " + file.tenTep}
                                                                            >
                                                                                <i className="fa fa-eye mr-2" />
                                                                                {shortFileName(file.tenTep)}
                                                                            </Button>
                                                                        </a>
                                                                        <a
                                                                            href={urlAdmin + file.duongDan?.replace(/\\/g, "/")}
                                                                            download={file.tenTep}
                                                                        >
                                                                            <Button
                                                                                className="hrm-btn hrm-btn-sm hrm-btn-success"
                                                                                title={"Tải về " + file.tenTep}
                                                                            >
                                                                                <i className="fa fa-download" />
                                                                            </Button>
                                                                        </a>
                                                                    </Space>
                                                                ))}
                                                            </Space>
                                                            : <label>Không có file đính kèm</label>}
                                                    </div>
                                                </Col>
                                            </Row>
                                        </div>
                                    </div>
                            },
                            {
                                key: '3',
                                label: "Lịch sử thao tác",
                                children: <LogNguoiDungTable data={data.logs} />
                            }
                        ]}>
                        </Tabs>
                    </div>
                </Col>
            </Row>
            {activeTab == "1" &&
                <>

                    <Row>
                        <Col span="24">
                            <div className="card-outline">
                                <Tabs
                                    items={[
                                        {
                                            key: '1',
                                            label: 'Thông tin lớp đào tạo',
                                            children:
                                                <div className="card pt-3 pb-2">
                                                    <div className="tab-content" style={{ marginLeft: "20px" }}>
                                                        <Row>
                                                            <Col span={8}>
                                                                <div className="mb-1">
                                                                    <div>Mã lớp</div>
                                                                    <label>{data?.ma}</label>
                                                                </div>
                                                                <div>
                                                                    <div>Chi phí khóa học</div>
                                                                    <label>{formatVND(data?.hocPhi)}</label>
                                                                </div>
                                                                <div className="mb-1">
                                                                    <div>Thời gian</div>
                                                                    <label>{dateCommon.formatDate(data?.ngayBatDau)} - {dateCommon.formatDate(data?.ngayKetThuc)}</label>
                                                                </div>
                                                            </Col>
                                                            <Col span={8}>
                                                                <div className="mb-1">
                                                                    <div>Tên lớp</div>
                                                                    <label>{data?.ten}</label>
                                                                </div>
                                                                <div className="mb-1">
                                                                    <div>Địa điểm tổ chức</div>
                                                                    <label>{data?.diaDiemToChuc}</label>
                                                                </div>
                                                                <div className="mb-1">
                                                                    <div>Hình thức tổ chức</div>
                                                                    {data?.idHinhThucToChuc == 2 ?
                                                                        <label>Nội bộ</label> : <label>Thuê ngoài</label>
                                                                    }
                                                                </div>
                                                            </Col>
                                                            <Col span={8}>
                                                                <div className="mb-1">
                                                                    <div>Giảng viên</div>
                                                                    <label>
                                                                        {data?.giangVien}
                                                                    </label>
                                                                </div>
                                                                <div className="mb-1">
                                                                    <div>Đơn vị đào tạo</div>
                                                                    <label>{data?.donViDaoTao}</label>
                                                                </div>
                                                                <div className="mb-1">
                                                                    <div>Số lượng nhân viên</div>
                                                                    <label>{dsNhanVien.length} Nhân viên</label>
                                                                </div>
                                                            </Col>
                                                        </Row>
                                                        <Row>
                                                            <Col span={24}>
                                                                <div className="mb-1">
                                                                    <div>Mô tả</div>
                                                                    <label>{data?.moTa}</label>
                                                                </div>
                                                            </Col>
                                                        </Row>
                                                    </div>
                                                </div>
                                        },
                                    ]}>
                                </Tabs>
                            </div>
                        </Col>
                    </Row>
                    <Row>
                        <Col span={24}>
                            <div className="card-outline">
                                <Tabs
                                    defaultActiveKey="1" items={[
                                        {
                                            key: '1',
                                            label: 'Danh sách nhân viên',
                                            children:
                                                <Table
                                                    locale={{ emptyText: "Không có dữ liệu" }}
                                                    dataSource={dsNhanVien}
                                                    pagination={false}
                                                    rowKey="id"
                                                    expandable={{
                                                        showExpandColumn: false,
                                                        // chỉ mở ô nhập chứng chỉ của dòng đang nhập kết quả và có tích "Cấp chứng chỉ"
                                                        expandedRowKeys: ketQuaEdit && ketQuaEdit.isCapChungChi ? [ketQuaEdit.id] : [],
                                                        expandedRowRender: () => formNhapChungChi(),
                                                    }}
                                                >
                                                    <Column
                                                        title="STT"
                                                        key="STT"
                                                        width="5%"
                                                        render={(value, record, index) =>
                                                        (
                                                            <>
                                                                {index + 1}
                                                            </>
                                                        )}
                                                    />
                                                    <Column title="Tên nhân viên" dataIndex="hoTen" key="hoTen" />
                                                    <Column className="text-center" title="Điểm đánh giá"
                                                        key="diemDanhGia"
                                                        render={(value: NhanVienTheoLopDaoTao, record, index) => (
                                                            index === rowIndex
                                                                ? <Input
                                                                    value={ketQuaEdit?.diemDanhGia}
                                                                    placeholder="Nhập điểm đánh giá"
                                                                    onChange={(e) => setKetQuaEdit(prev => prev ? { ...prev, diemDanhGia: e.target.value } : prev)}
                                                                />
                                                                : <>{value.diemDanhGia}</>
                                                        )}
                                                    />
                                                    <Column className="text-center" title="Kết quả đào tạo"
                                                        key="ketQuaDaoTao"
                                                        render={(value: NhanVienTheoLopDaoTao, record, index) => (
                                                            index === rowIndex
                                                                ? <Input
                                                                    value={ketQuaEdit?.ketQuaDaoTao}
                                                                    placeholder="Nhập kết quả đào tạo"
                                                                    onChange={(e) => setKetQuaEdit(prev => prev ? { ...prev, ketQuaDaoTao: e.target.value } : prev)}
                                                                />
                                                                : <>{value.ketQuaDaoTao}</>
                                                        )}
                                                    />
                                                    <Column className="text-center" title="Cấp chứng chỉ"
                                                        key="isCapChungChi"
                                                        render={(value: NhanVienTheoLopDaoTao, record, index) => (
                                                            index === rowIndex
                                                                ? <Checkbox
                                                                    checked={ketQuaEdit?.isCapChungChi}
                                                                    onChange={(e) => setKetQuaEdit(prev => prev ? { ...prev, isCapChungChi: e.target.checked } : prev)}
                                                                />
                                                                : <>
                                                                    <Checkbox checked={value.isCapChungChi}></Checkbox>
                                                                    {value.isCapChungChi && value.chungChi &&
                                                                        <div className="text-muted">
                                                                            {value.chungChi.tenChungChi}
                                                                            {value.chungChi.ngayCapChungChi ? ` (${dateCommon.formatDate(value.chungChi.ngayCapChungChi)})` : ""}
                                                                        </div>}
                                                                </>
                                                        )}
                                                    />{
                                                        trangThai >= trangThaiLopDaoTao.pheDuyet && (data.idNVTheoDoi == user.idNhanVien || user.isAdmin) && 

                                                        <Column className="text-center"
                                                            title="Hành động"
                                                            key="action"
                                                            render={(value: NhanVienTheoLopDaoTao, record, index) => {
                                                                return (
                                                                    <>
                                                                        <Space>
                                                                            {index === rowIndex  ? null
                                                                                :
                                                                                <Button type="primary"
                                                                                    icon=<EditOutlined rev="" />
                                                                                    size={"small"}
                                                                                    disabled={rowIndex >= 0}
                                                                                    onClick={() => {
                                                                                        batDauCapNhatKetQua(index, value);
                                                                                    }}>Cập nhật</Button>
                                                                            }
                                                                            {index === rowIndex && <>
                                                                                <Button className="hrm-btn-success"
                                                                                    type="primary"
                                                                                    size={"small"}
                                                                                    icon=<SaveOutlined rev="" />
                                                                                    onClick={() => { luuKetQuaDaoTao(); }}>Lưu</Button>
                                                                                <Button className="hrm-btn-delete"
                                                                                    type="primary"
                                                                                    size={"small"}
                                                                                    icon=<CloseOutlined />
                                                                                    onClick={() => { huyCapNhatKetQua(); }}>Hủy</Button>
                                                                            </>}
                                                                        </Space>
                                                                    </>
                                                                )
                                                            }}
                                                        />
                                                    }
                                                </Table>
                                        },
                                    ]}>
                            </Tabs>
                            {isNVTheoDoi
                                    &&
                                    <Row className="mt-1 mb-1">
                                        <Col span="24">
                                            <FloatButton.Group
                                                trigger="hover"
                                                type="primary"
                                                style={{ right: 50, bottom: 80 }}
                                            >
                                                <FloatButton
                                                    tooltip="Chỉnh sửa thông tin lớp đào tạo"
                                                    className="hrm-btn-warning"
                                                    icon={<EditOutlined rev="" />}
                                                    onClick={() => {
                                                        navigate(Links.DaoTao.ChiTiet + "?id=" + id);
                                                    }}
                                                />
                                                <FloatButton
                                                    tooltip="Xóa lớp đào tạo"
                                                    className="hrm-btn-delete"
                                                    icon={<DeleteOutlined rev="" />}
                                                    onClick={() => setOpenModalXoa(true)}
                                                />

                                            </FloatButton.Group>
                                        </Col>
                                    </Row>}
                            </div>
                        </Col>
                    </Row>
                </>
            }
        </section>
    )
}

export default XemLopDaoTao;